 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","11":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotels~modern_deskto~b89c92da","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","14":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","15":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","17":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotel_checkout~hotels~order~order_changing_requ~b5f5baf1","18":"vendors~Cigarette~about~client~header_app~hotels~modern_desktop_home~modern_mobile_home~order~search~6078161e","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","26":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","27":"Header~alfa_pay~gift_certificate~pay_card~t_pay","28":"vendors~Header~about~faq~header_app","30":"vendors~Cigarette~EmptySearch~tinkoff_iframe","31":"vendors~Cigarette~HotelNotice~tinkoff_iframe","32":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","33":"vendors~Header~about~header_app","35":"AuthNew~ClientFormContainer","36":"FiltersPanel","37":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptySearch","47":"ExpensiveHotelsPopup","48":"FiltersPanelMobile","49":"FlightFail","50":"FlightsItem","51":"Header","52":"HeaderAuth","53":"HotelNotice","54":"IosIcon","55":"Map","56":"MountainsContainer","57":"NoTopHotel","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"cd9037f1e7722d9a3982","11":"b0755e8d09438a471994","12":"b2d03ac24175c5c14f56","14":"111d5e3beb19920d1db7","15":"6d052e6f861c8425b660","17":"aaafd1b7a3f42dc5ee6a","18":"f991471b14cf076940f8","20":"0a997a85fadabc975f43","21":"6c46bde232bc8b83e7eb","23":"f6a044e8a61afa6d4b32","26":"2656334e90a334169d48","27":"cae6ae8a3f3b57ea7f57","28":"3db5ff13b2c5ab4051e4","30":"bb2e3cf6a935ec9c197d","31":"111d7129d17bd903c905","32":"4cc9f1264983efb78750","33":"26f0712924b296ea6424","35":"419588b3848151f26486","36":"2fbc33113e5e587808cd","37":"29bf7a721948785467d5","38":"fe61cf32b972d9a2c381","39":"99222af7a9b844cdc406","40":"a609e8cfef794def0d6e","41":"3a306cbeeda18fe2b9ff","42":"902955701bc0b7c58380","43":"78c479efa9e2652c241e","44":"b164e32c818a4c32bfcc","45":"2792e9e2c6ef597ad5eb","46":"42e60308eaa16687cbc7","47":"a1d6c70ae5dbc325214b","48":"c7954ece82cbe4b5df37","49":"4c4ab4881cc44ae7c573","50":"b00363e2998eb0ea0e4c","51":"27d91b2bc768923c58af","52":"5b7dd9d92ee70d78329d","53":"b1d73d5a1b8284526a21","54":"2c3839307970be1aa797","55":"05bb2997d3dba4447717","56":"f9a748505c529c58e399","57":"80d604f1f34e1e6fbc02","58":"78c2cdcb18e8ddb06d61","59":"0a14227530e79c236ad1","60":"c4448a78df90bf08ee64","61":"51b8bc8723f740612591","62":"22e96bfca5c69a00f151","63":"9c71a5ab18fec2cb80f7","64":"b20697bb116dda5f5c18","65":"ea3613fa8d230f37ec06","66":"a0be733ace15146b6fe5","67":"074330cea12674ee1846","68":"90d27cd6175242afc3b1","69":"81f3ad35c350145a78bc","93":"efbf9fc8312ced70fada","99":"89cb938b8c2952e622ef","100":"159a0516682654b385d2","106":"aefad2faf90b8b266e1e"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"35":1,"36":1,"37":1,"42":1,"46":1,"47":1,"49":1,"51":1,"52":1,"55":1,"57":1,"59":1,"60":1,"62":1,"67":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","11":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotels~modern_deskto~b89c92da","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","14":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","15":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","17":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotel_checkout~hotels~order~order_changing_requ~b5f5baf1","18":"vendors~Cigarette~about~client~header_app~hotels~modern_desktop_home~modern_mobile_home~order~search~6078161e","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","26":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","27":"Header~alfa_pay~gift_certificate~pay_card~t_pay","28":"vendors~Header~about~faq~header_app","30":"vendors~Cigarette~EmptySearch~tinkoff_iframe","31":"vendors~Cigarette~HotelNotice~tinkoff_iframe","32":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","33":"vendors~Header~about~header_app","35":"AuthNew~ClientFormContainer","36":"FiltersPanel","37":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptySearch","47":"ExpensiveHotelsPopup","48":"FiltersPanelMobile","49":"FlightFail","50":"FlightsItem","51":"Header","52":"HeaderAuth","53":"HotelNotice","54":"IosIcon","55":"Map","56":"MountainsContainer","57":"NoTopHotel","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"46dece15f15328607ba7","11":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","14":"d41d8cd98f00b204e980","15":"d41d8cd98f00b204e980","17":"d41d8cd98f00b204e980","18":"d41d8cd98f00b204e980","20":"d41d8cd98f00b204e980","21":"d41d8cd98f00b204e980","23":"d41d8cd98f00b204e980","26":"d41d8cd98f00b204e980","27":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","31":"d41d8cd98f00b204e980","32":"d41d8cd98f00b204e980","33":"d41d8cd98f00b204e980","35":"44608e06e212a6b73368","36":"cda3a38be2bc039e1f3e","37":"62f06f83662e5d10640f","38":"d41d8cd98f00b204e980","39":"d41d8cd98f00b204e980","40":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"8b56781ad92a57b73497","43":"d41d8cd98f00b204e980","44":"d41d8cd98f00b204e980","45":"d41d8cd98f00b204e980","46":"7bc690fbfb444b4fb1b5","47":"9686519f282e3233d6e6","48":"d41d8cd98f00b204e980","49":"3d5c7660f989b289df97","50":"d41d8cd98f00b204e980","51":"362fe1d85584923dbd44","52":"e2dc08d21432f13fd3cc","53":"d41d8cd98f00b204e980","54":"d41d8cd98f00b204e980","55":"10dcb55c3c7ae5da89f7","56":"d41d8cd98f00b204e980","57":"48f423a35a0b323e4a7d","58":"d41d8cd98f00b204e980","59":"a65265f17a8153dfeb55","60":"4e7d0822a16063d2594e","61":"d41d8cd98f00b204e980","62":"a60208ae14d613f1fd1a","63":"d41d8cd98f00b204e980","64":"d41d8cd98f00b204e980","65":"d41d8cd98f00b204e980","66":"d41d8cd98f00b204e980","67":"05caa9d97f0d66d5cb8f","68":"4e4bce3e48155e11f05a","69":"6db49fca7fc02b2cb0dd","93":"d41d8cd98f00b204e980","99":"d41d8cd98f00b204e980","100":"d41d8cd98f00b204e980","106":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
